import { createAction, props } from '@ngrx/store';
import {
  AdditionalConfiguration,
  ReportDataMap,
  ReportSectionConfigForDraggableItem,
  ReportSectionConfigurationWithOrder,
  ReportTemplate,
  TemplateDetailsError
} from '@capital-access/reporting/common';

export const openEditReportingTemplateDrawer = createAction(
  '[Reporting] Open Edit Report Template Drawer',
  props<{ reportType: string }>()
);

export const deleteTemplateActivityInitiated = createAction('[Activity Form] Delete Activity Initiated');

export const initialUpdateReportSections = createAction(
  scoped`Load Template Designer`,
  props<{
    reportTemplate: ReportTemplate;
    reportSections: ReportSectionConfigurationWithOrder[];
    draggableItems: ReportSectionConfigForDraggableItem[];
    initial: boolean;
  }>()
);

export const formatReportSectionsAsDraggableItems = createAction(
  scoped`Format Report Sections`,
  props<{ formattedDraggableItems: ReportSectionConfigForDraggableItem[] }>()
);

export const reportSectionSelected = createAction(
  scoped`Report Section Selected`,
  props<{ selectedReport: ReportSectionConfigForDraggableItem | null }>()
);

export const reportSectionSelectedViaCanvas = createAction(
  canvasScoped`Report Section Selected via canvas`,
  props<{ selectedReport: ReportSectionConfigurationWithOrder | undefined }>()
);

export const goBackToReportConfiguration = createAction(scoped`Go Back To Report Configuration`);

export const onReportSectionCheckboxToggle = createAction(
  scoped`Report Section Checked`,
  props<{ reportSection: ReportSectionConfigForDraggableItem; checked: boolean }>()
);

export const onReportSectionUnchecked = createAction(
  scoped`Report Section Unchecked`,
  props<{ reportSection: ReportSectionConfigForDraggableItem }>()
);

export const onReportSectionConfigCheckboxToggleFromDetailsPage = createAction(
  scoped`Report Section Checkbox Toggle From Details Page`,
  props<{ reportSection: ReportSectionConfigForDraggableItem; checked: boolean }>()
);

export const onReportSectionConfigDataPointToggle = createAction(
  scoped`Report Section Data Point Checked`,
  props<{ dataSection: ReportSectionConfigForDraggableItem; checked: boolean }>()
);

export const onReportSectionDataPointSelectClearAll = createAction(
  scoped`Report Section Data Point Select All`,
  props<{ selectAll: boolean }>()
);
export const onReportSectionConfigAdditionalDataChanged = createAction(
  scoped`Report Section Additional Data Changed`,
  props<{ dataSection: ReportSectionConfigurationWithOrder; additionalConfiguration: AdditionalConfiguration }>()
);

export const onReportSectionWidthChanged = createAction(
  scoped`Report Section Width Changed`,
  props<{ reportSection: ReportSectionConfigForDraggableItem; width: number }>()
);

export const clearErrorMessage = createAction(scoped`Clear Error Message`);

export const onReportSectionOrderChanged = createAction(
  scoped`Report Section Order Changed`,
  props<{ draggableItems: ReportSectionConfigForDraggableItem[] }>()
);

export const onReportSectionCanvasChanged = createAction(
  scoped`Report Section Canvas Changed`,
  props<{ changedReportSections: ReportSectionConfigurationWithOrder[] }>()
);

export const updateActivityHistoryCount = createAction(
  scoped`Update Activity History Count`,
  props<{ activityHistoryCount: number }>()
);

export const saveTemplateDetails = createAction(
  scoped`Save Template Details`,
  props<{ redirectToExport: boolean; initial: boolean }>()
);

export const saveTemplateDetailsSuccess = createAction(
  scoped`Save Template Details Success`,
  props<{ reportTemplate: ReportTemplate; redirectToExport: boolean; initial: boolean }>()
);

export const saveTemplateDetailsFailure = createAction(scoped`Save Template Details Failure`);

export const getTemplateDetailsById = createAction(
  scoped`Get Template Details By Id`,
  props<{ templateId: number; initial: boolean }>()
);

export const getTemplateDetailsByIdFailed = createAction(
  scoped`Get Template Details By Id Failed`,
  props<{ error: TemplateDetailsError }>()
);

export const updateReportData = createAction(
  scoped`Update Report Data`,
  props<{ reportData: ReportDataMap; sampleData: boolean }>()
);

export const toggleSelectionByParticipant = createAction(scoped`Toggle Activity History Selection By Participant`);

export const clearTemplateDesignerState = createAction(scoped`Clear Template Designer State`);

export const reportSectionSelectAll = createAction(scoped`Report Section Select All`);

export const reportSectionClearAll = createAction(scoped`Report Section Clear All`);

export const onEmptySelectionAlert = createAction(scoped`Toggle empty selection alert`, props<{ show: boolean }>());

export const setCombinedOwnershipEnabled = createAction(
  '[Template Designer] Set Combined Ownership Enabled',
  props<{ enabled: boolean }>()
);

export const setNotesFeatureEnabled = createAction(scoped`Set Notes Feature Enabled`, props<{ enabled: boolean }>());

export const onHideExportWarning = createAction(scoped`Hide Export Warning`);

export const onHideSelectWarning = createAction(scoped`Hide Select Warning`);

export const changeItineraryTab = createAction(scoped`Change Itinerary Tab`, props<{ selectedTab: string }>());

export function scoped(templateString: TemplateStringsArray) {
  return '[Template Designer] ' + templateString[0];
}

function canvasScoped(templateString: TemplateStringsArray) {
  return '[Canvas]' + templateString[0];
}
